import { action, makeAutoObservable } from "mobx"
import request from "../../../util/request"

import Package from "../../../models/Package"
import Participation from "../../../models/Participation"
import { Section } from "./Section"

export default class Assignment {
  id: number
  participation: Participation
  tripId: number
  sectionId?: number

  constructor(props: any) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.id = props.id
    this.sectionId = props.sectionId
    this.participation = props.participation && new Participation(props.participation)
    this.tripId = this.participation && this.participation.tripId
  }

  get passengerName(): string {
    return this.participation.person.adminFormattedName
  }

  get passengerLastName(): string {
    return this.participation.person.lastName
  }

  get passengerAge(): number {
    return this.participation.person.age
  }

  get gender(): string {
    return this.participation.person.gender
  }

  get package(): Package | undefined {
    return this.participation.package
  }

  assignToSection(s: Section) {
    this.apiUpdateListId(s.id)
  }

  unassign() {
    this.apiUpdateListId(undefined)
  }

  apiUpdateListId(newListId: number | undefined) {
    const prevListId = this.sectionId
    this.sectionId = newListId

    let apiRequest = request("PUT", `/api/v1/trips/${this.tripId}/assignments/${this.id}`, {
      section_id: newListId || "",
    })

    apiRequest.then(
      (_result) => {},
      action("fetchError", (error) => {
        console.log("Assignment.assignToSection API error", error)
        this.sectionId = prevListId
      }),
    )
  }
}
